export default __webpack_public_path__ + "static/media/signinManage.88c7979a.png";